import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import AddLeadModal from '../../pages/lead-management/components/AddLeadModal';
import SendCampaignModal from '../../pages/lead-management/components/SendCampaignModal';

const QuickActionPanel = ({ className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAddLeadOpen, setIsAddLeadOpen] = useState(false);
  const [isSendCampaignOpen, setIsSendCampaignOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    {
      id: 'add-lead',
      label: 'Add Lead',
      icon: 'UserPlus',
      description: 'Manually add new lead',
      iconBgColor: 'bg-blue-600',
      iconColor: 'text-white',
      onClick: () => setIsAddLeadOpen(true)
    },
    {
      id: 'send-campaign',
      label: 'Send Campaign',
      icon: 'Send',
      description: 'Launch email outreach',
      iconBgColor: 'bg-blue-600',
      iconColor: 'text-white',
      onClick: () => setIsSendCampaignOpen(true)
    },
    {
      id: 'bulk-actions',
      label: 'Bulk Actions',
      icon: 'CheckSquare',
      description: 'Manage multiple leads',
      iconBgColor: 'bg-gray-100',
      iconColor: 'text-gray-700',
      onClick: () => navigate('/lead-management?mode=bulk')
    },
    {
      id: 'view-analytics',
      label: 'View Analytics',
      icon: 'BarChart3',
      description: 'Check performance metrics',
      iconBgColor: 'bg-green-600',
      iconColor: 'text-white',
      onClick: () => navigate('/analytics-dashboard')
    }
  ];

  const handleActionClick = (action) => {
    try {
      if (action?.onClick && typeof action?.onClick === 'function') {
        action?.onClick();
      }
      setIsExpanded(false);
    } catch (error) {
      console.error('Action click error:', error);
    }
  };

  return (
    <>
      <div className={`${className}`}>
        {/* Desktop Version */}
        <div className="hidden md:block">
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-900">
                Quick Actions
              </h3>
            </div>

            {/* 2x2 Grid Layout */}
            <div className="grid grid-cols-2 gap-4">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleActionClick(action)}
                  className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md hover:border-gray-300 transition-all duration-200 text-left group"
                >
                  <div className="flex items-start space-x-3">
                    <div className={`p-3 rounded-lg ${action?.iconBgColor} shrink-0`}>
                      <Icon
                        name={action?.icon}
                        size={20}
                        className={action?.iconColor}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-gray-900 mb-1">
                        {action?.label}
                      </h4>
                      <p className="text-xs text-gray-600 leading-relaxed">
                        {action?.description}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Floating Action Button */}
        <div className="md:hidden fixed bottom-6 right-6 z-50">
          <div className="relative">
            {isExpanded && (
              <div className="absolute bottom-16 right-0 space-y-3 animate-in slide-in-from-bottom-4 duration-300">
                {actions?.slice(0, 3)?.map((action, index) => (
                  <div
                    key={action?.id}
                    className="flex items-center space-x-3 animate-in slide-in-from-bottom-2"
                    style={{
                      animationDelay: `${index * 50}ms`,
                      animationFillMode: 'both'
                    }}
                  >
                    <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-sm font-medium shadow-lg whitespace-nowrap border border-gray-200">
                      {action?.label}
                    </div>
                    <button
                      onClick={() => handleActionClick(action)}
                      className={`w-12 h-12 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 ${action?.iconBgColor} flex items-center justify-center`}
                    >
                      <Icon name={action?.icon} size={20} className={action?.iconColor} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="w-14 h-14 rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl hover:bg-blue-700 transition-all duration-200 flex items-center justify-center"
            >
              <Icon
                name={isExpanded ? 'X' : 'Plus'}
                size={24}
                className={`transition-transform duration-200 ${isExpanded ? 'rotate-90' : 'rotate-0'}`}
              />
            </button>
          </div>

          {isExpanded && (
            <div
              className="fixed inset-0 bg-black/20 backdrop-blur-sm -z-10 animate-in fade-in duration-200"
              onClick={() => setIsExpanded(false)}
            />
          )}
        </div>
      </div>

      {/* Modals */}
      <AddLeadModal
        isOpen={isAddLeadOpen}
        onClose={() => setIsAddLeadOpen(false)}
        onLeadAdded={() => setIsAddLeadOpen(false)}
      />

      <SendCampaignModal
        isOpen={isSendCampaignOpen}
        onClose={() => setIsSendCampaignOpen(false)}
        selectedLeads={[]}
        leads={[]}
      />
    </>
  );
};

export default QuickActionPanel;